/* @ngInject */
export default function LeftNavUserController($scope, CurrentUserManager) {
  const _this = this;

  _this.currentUserManager = CurrentUserManager;
}
